import { z } from 'zod'

export const ameliaAssetIdSchema = z.string().regex(/^[a-f0-9]{32}$/)
export interface AmeliaAsset {
  id: string
  name: string
  os: 'windows' | 'macos' | 'linux'
  architecture: 'arm64' | 'x64' | 'unknown'
  format: string
}
export interface AmeliaRelease {
  version: string
  releasedAt: string
  assets: AmeliaAsset[]
}

export function ameliaOperatingSystem(userAgent: string): AmeliaAsset['os'] | undefined {
  if (/android|iphone|ipad/i.test(userAgent)) return undefined
  if (/windows/i.test(userAgent)) return 'windows'
  if (/macintosh|mac os x/i.test(userAgent)) return 'macos'
  if (/linux/i.test(userAgent)) return 'linux'
  return undefined
}
